
import { Container, Row, Col } from "react-bootstrap";
import quoteImg from "../assets/img/getStarted.png";
//import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const QuoteText = () => {
 
  return (
    <section className="career" id="career">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h1>30-Minutes Free <span className='quoteHeader'>Strategy</span> Session</h1>
                <h4>Lets Relate...</h4>
                  <p>
                    Get your 100% FREE no-obligation 30-Minutes Strategy Session Call --Normally worth $60-- We will discuss your goals, craft a plan that works best for you, and answer any question you have.
                  </p>
                  <br />
                  <h3>WHAT TO EXPECT:</h3>
                  <p>
                    * An immediate email confirming your request. NOTE: if you don't get it, please check your spam.
                  </p>
                  <p>
                    * We will work together to clarify your requirements.
                  </p>
                  <p>
                    * We will share ideas on how to help you achieve your desired goals.
                  </p>
                  <p>
                    * We will send you a custom quote or proposal whenever you're ready to begin.
                  </p><br />
                  
                  <h5 className="chris">Connect Via WhatsApp now</h5>
                  <p className="chris"><a href="https://wa.me/2347064931387">WhatsApp Link</a></p>
                  <h5 className="chris">Or Use The Form Bellow</h5>
                  
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={quoteImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
